import { RouteConfig } from 'vue-router';
import { requireProvider } from '@/router/guards/authGuards';
import { checkSitterOnboarding } from '@/router/guards/completionGuards';
import combineGuards from '@/router/guards/helpers';

const bookingsRoutes: RouteConfig[] = [
  {
    path: '/provider/bookings',
    name: 'provider-bookings',
    component: () => import('@/apps/provider/bookings/ProviderBookings.vue'),
    beforeEnter: combineGuards([requireProvider, checkSitterOnboarding]),
  },
  {
    path: '/provider/bookings/booking/accepted/:contractId',
    name: 'provider-booking-accepted',
    component: () => import('@/apps/provider/bookings/booking/accepted/ProviderBookingAccepted.vue'),
    props: (route) => ({ contractId: route.params.contractId }),
    beforeEnter: combineGuards([requireProvider, checkSitterOnboarding]),
  },
  {
    path: '/provider/bookings/booking/confirmed/:contractId',
    name: 'provider-booking-confirmed',
    component: () => import('@/apps/provider/bookings/booking/confirmed/ProviderBookingConfirmed.vue'),
    props: (route) => ({ contractId: route.params.contractId }),
    beforeEnter: combineGuards([requireProvider, checkSitterOnboarding]),
  },
  {
    path: '/provider/bookings/interview/accepted/:contractId',
    name: 'provider-interview-accepted',
    component: () => import('@/apps/provider/bookings/interview/accepted/ProviderInterviewAccepted.vue'),
    props: (route) => ({ contractId: route.params.contractId }),
    beforeEnter: combineGuards([requireProvider, checkSitterOnboarding]),
  },
  {
    path: '/provider/bookings/:contractId',
    name: 'provider-contract',
    component: () => import('@/apps/provider/bookings/[contractId].vue'),
    props: (route) => ({ contractId: route.params.contractId }),
    beforeEnter: combineGuards([requireProvider, checkSitterOnboarding]),
  },
];

export default bookingsRoutes;
